import { render, staticRenderFns } from "./ScanDetail.vue?vue&type=template&id=41b8628a&"
import script from "./ScanDetail.vue?vue&type=script&lang=js&"
export * from "./ScanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScanDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports